import { render, staticRenderFns } from "./KeywordsCompetitors.vue?vue&type=template&id=bdde3812&scoped=true"
import script from "./KeywordsCompetitors.vue?vue&type=script&lang=js"
export * from "./KeywordsCompetitors.vue?vue&type=script&lang=js"
import style0 from "./KeywordsCompetitors.vue?vue&type=style&index=0&id=bdde3812&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdde3812",
  null
  
)

export default component.exports